import { render } from "./UploadFormComponent.vue?vue&type=template&id=54c439e4"
import script from "./UploadFormComponent.vue?vue&type=script&lang=js"
export * from "./UploadFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__